import clsx from "clsx";
import { HTMLAttributes, ReactNode } from "react";

export interface TableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  /**
   * Preferencialmente Table.Cell.
   * ReactNode é aceito para permitir map(), fragments e renderização condicional.
   */
  children: ReactNode;
}

export const TableRow = ({ children, className, ...props }: TableRowProps) => (
  <tr className={clsx(className)} {...props}>
    {children}
  </tr>
);
